'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageBrightness3 = function ImageBrightness3(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z' })
  );
};
ImageBrightness3 = (0, _pure2.default)(ImageBrightness3);
ImageBrightness3.displayName = 'ImageBrightness3';
ImageBrightness3.muiName = 'SvgIcon';

exports.default = ImageBrightness3;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/brightness-3.js
 ** module id = 2030
 ** module chunks = 0
 **/